module.exports = __webpack_public_path__ + "img/gzh1.a104df90.png";